export default {
  TitleFormName: 'Tìm kiếm chứng từ',
  EventName: {
    ViewVoucher: 'Xem chứng từ',
    ExportExcel: 'Xuất Excel',
    AddCondition: 'Thêm điều kiện',
    Search: 'Tìm kiếm',
    Delete: 'Xóa',
    Print: 'In',
    Cancel: 'Hủy',
    Analysis: 'Phân tích',
  },
  ScreenText: {
    DatePeriod: 'Thời gian',
    VoucherPosted: 'Chứng từ đã ghi sổ',
    VoucherNoPost: 'Chứng từ chưa ghi sổ',
    AllVoucher: 'Tất cả chứng từ',
    GroupByVoucher: 'Nhóm theo chứng từ',
    Search: 'Tìm theo',
    Condition: 'Điều kiện',
    FromDate: 'Từ ngày',
    ToDate: 'Đến ngày',
    FromValue: 'Từ giá trị',
    ToValue: 'Đến giá trị',
    value: 'Giá trị',
    Title: 'Tìm chứng từ',
    PrintTitle: 'Chọn cột cần in',
    WarningContent: 'Bạn hãy chọn chứng từ cần xem chi tiết.',
    WarningTitle: 'Cảnh báo',
  },
  Print: {
    TitleContent: 'Tiêu đề',
    AdjustColumnTitle: 'Điều chỉnh kích thước cột',
    AdjustAll: 'Điều chỉnh tất cả các cột',
    AdjustFinal: 'Điều chỉnh cột cuối cùng',
    NoAdjust: 'Không điều chỉnh',
  },
  Enum: {
    Date: 1,
    Number: 2,
    MLNS: 3,
    Money: 4,
    FixedAsset: 5,
    Cash: 6,
    Quantity: 7,
    VoucherCategory: 8,
    ObjectCategory: 9,
    Equals: 0,
  },
  ControlSearch: {
    PostedDate: 'Ngày hạch toán',
    RefType: 'Loại chứng từ',
    RefDate: 'Ngày chứng từ',
    RefNo: 'Số chứng từ',
    DebitAccount: 'TK Nợ',
    CreditAccount: 'TK Có',
    Amount: 'Số tiền',
    StateAmount: 'Thu NSNN',
    InventoryItemCode: 'Vật tư/ CCDC',
    BudgetSource: 'Nguồn',
    BudgetSourceProperty: 'Tính chất nguồn kinh phí',
    BudgetProvideCode: 'Mã dự phòng',
    BudgetChapter: 'Chương',
    BudgetKindItemCode: 'Loại',
    BudgetSubKindItemCode: 'Khoản',
    BudgetItemCode: 'Mục',
    BudgetSubItemCode: 'Tiểu mục',
    BudgetItemDetailCode: 'Tiết',
    StockCode: 'Kho',
    Quantity: 'Số lượng',
    AccountingObjectCategoryName: 'Loại đối tượng',
    AccountingObjectCode: 'Đối tượng',
    ActivityCode: 'Hoạt động tài chính',
    CashWithdrawTypeId: 'Nghiệp vụ',
    Description: 'Diễn giải',
    FixedAssetCode: 'Tài sản cố định',
    FundStructureCode: 'Quỹ tiền',
    StatisticCode: 'Mã thống kê',
    LocalBudgetItemName: 'Khoản chi xã',
    BankAccount: 'Tài khoản Ngân hàng, Kho bạc',
    ProjectCode: 'CTMT, DA',
    OrgVoucherDate: 'Ngày chứng từ gốc',
    OrgVoucherNo: 'Số chứng từ gốc',
    InvDate: 'Ngày hóa đơn',
    InvNo: 'Số hóa đơn',
  },
};
